const noop = ()=>{}

export class TaskHelper {
    static waitFor(condition, task, interval=50, timeout=5000, timeoutTask=noop) {
        let ref = {idInterval: -1, idTimeout: -1}
        ref.idInterval = setInterval(() => {
            if (condition() && ref.idTimeout>0) {
                task()

                clearInterval(ref.idInterval)
                clearTimeout(ref.idTimeout)
            }
        }, interval)
        ref.idTimeout = setTimeout(() => {
            clearInterval(ref.idInterval)
            timeoutTask()
        }, timeout)
    }
}

export default TaskHelper